import React from 'react';
import OrderData from './OrderData';
import LogisticsData from './LogisticsData';
import * as Grants from '.././util/grants';
import { hasGrant } from '.././util/grantHelper';
import axios from 'axios';
import constants from '../util/constants';

const { API_BASE_URL } = constants;

class Dashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = { clients: undefined, selectValue: '', isOrderDataLoading: true };
    this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
    this.getClientCodes = this.getClientCodes.bind(this);
    this.setIsLoadingForCCRPicker = this.setIsLoadingForCCRPicker.bind(this);

  }

  componentDidMount(){
    this.axiosCancelSource = axios.CancelToken.source();
    this.getClientCodes();
  }
  componentWillUnmount () {
    this.axiosCancelSource.cancel('Component unmounted.')
  }
  

    
  getClientCodes() {
    const self = this;
    const getCustomers = 'Order/GetCustomers';
    const options = { headers: { 'Authorization': 'Bearer ' + self.props.apiToken }, cancelToken: this.axiosCancelSource.token };

    axios.get(API_BASE_URL + getCustomers, options)
    .then(function (response) {
      self.setState({
        clients: response.data
      });
    })
    .catch(function (error) {
    
    });
  }

  handleClientSelectChange(item) {
    let value=(item && item.value) || '';
      this.setState({ selectValue: value });
  }

  setIsLoadingForCCRPicker(state) {
    this.setState({ isOrderDataLoading: state });
  }

  render() {
    let c = this.state.clients; 
    let o = c ? c.map(f => ( {value: f.CLIENT_CODE_REGIONAL, label: f.CLIENT_CODE_REGIONAL + ' - ' + f.SHORT_NAME})) : [];

    return(
      <div>
            <div className="margin-top-10">
                {hasGrant(Grants.TYPES.Dashboard_ViewOrderInfo) && 
                    <OrderData apiToken={this.props.apiToken} ccr={this.state.selectValue} setIsLoadingForCCRPicker={this.setIsLoadingForCCRPicker} />
                }
                {hasGrant(Grants.TYPES.Dashboard_ViewShippingInfo) && 
                    <LogisticsData apiToken={this.props.apiToken} ccr={this.state.selectValue} />
                }        
        </div>
      </div>
    )
  }
}

export default Dashboard;